var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-8 h-8"},[_c('router-link',{attrs:{"to":_vm.dashboardPath,"replace":""}},[_c('img',{staticClass:"w-full h-full object-contain",attrs:{"src":"https://onexus.net/assets/onexus-logo.png","alt":_vm.name}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }